import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { IGetCallFlowViewModel, IServerResponse } from 'src/app/model/add-view-call-flow.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CallFlowDetialService {
  constructor(private httpClient: HttpClient) {}

  getCallFlowDetails$(data: IGetCallFlowViewModel): Observable<IServerResponse> {
    return this.httpClient
      .get<IServerResponse>(`${environment.apiHost}/CallFlowAndCheckList/${data.ServicerequestId}/${data.CurrentBusinessUnitId}`)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  removeFileFromCallFlow(fileId: string): Observable<IServerResponse> {
    return this.httpClient
      .delete<IServerResponse>(`${environment.apiHost}/${'Files'}/${'deleteFile?'}${fileId}`)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getAllCallFlowDetails(currentBusinessUnitId: string): Observable<IServerResponse> {
    return this.httpClient
      .get<IServerResponse>(`${environment.apiHost}/CallFlowAndCheckList/${currentBusinessUnitId}`)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
